import React from "react";
import CartFunnelSmsCampaign from "../../../components/Pages/Campaign/CartFunnel/Sms";

const CartFunnelSms = () => {
  return (
    <div>
      <CartFunnelSmsCampaign />
    </div>
  );
};

export default CartFunnelSms;
